import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'my-recibo-pago-descargar',
  styles: [],
  templateUrl: './recibo-pago-descargar.component.html',
  providers: [generalService]
})
export class ReciboPagoDescargarComponent implements OnInit {

  mensaje: string = '';
  confirm: boolean;
  constructor(
    public dataService: DataService,
    public dialogRef: MatDialogRef<ReciboPagoDescargarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
   
  }

  ngOnInit() {
   
  }


  cerrarModal() {
    this.dialogRef.close(false);
  }

  aceptar() {
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/recibo-pago/consultar-eliminar/recibo-pago-descargar.component.ts